import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post/page";
import BookPage from "../pages/book/page";
import WantMorePage from "../pages/want-more/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsOfUsePage from "../pages/terms-of-use/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/lore",
    element: <BlogPage />,
  },
  {
    path: "/lore/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/book",
    element: <BookPage />,
  },
  {
    path: "/want-more",
    element: <WantMorePage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUsePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
